import {
  confirmDialog,
  CustomButton,
  CustomCheckbox,
  CustomCollapseCard,
  CustomImage,
  CustomInput,
  CustomMaskInput,
  CustomMoneyInput,
  CustomPagination,
  CustomTable,
  EditableCell,
  errorDialog,
  successDialog,
  Text,
  useText,
  warningDialog,
} from '@src/components';
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import DeliveryAddressAddForm from './DeliveryAddressAddForm';
import DeliveryAddressChooseForm from './DeliveryAddressChooseForm';
import '@src/styles/cardOrder/cardDetailInformation.scss';
import { Button, Form, Tooltip, Typography } from 'antd';
import downloadIcon from '@src/assets/icons/icon-download.svg';
import excelIcon from '@src/assets/icons/icon-excel.svg';
import uploadIcon from '@src/assets/icons/icon-upload.svg';
import cardIcon from '@src/assets/icons/icon-kart.svg';
import { formPhoneRegex } from '@src/utils/formRule';
import { useDispatch, useSelector } from 'react-redux';
import { cardOrdersSave } from '@src/store/slice/cardOrderSlice';
import {
  cardOrderDetailDelete,
  cardOrderDetailSave,
  cardOrderDetailsGelAll,
  cardOrderDetailUpdate,
  setCardList,
  setSelectedRow,
} from '@src/store/slice/cardOrderDetailtsSlice';
import cardOrderDetailsServices from '@src/services/cardOrderDetails.services';
import { getFileNameByLanguage, isGreaterMaximumLoadedAmount, moneyFormat } from '@src/utils/utils';
import iconPlus from '@src/assets/icons/icon-plus.svg';
import iconChecked from '@src/assets/icons/icon-checked.svg';
import iconNoChecked from '@src/assets/icons/icon-no-check.svg';
import UploadFileModal from './UploadFileModal';
import download from 'js-file-download';
import dayjs from '@src/utils/day';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';
import { addressGetPagedListByUserQuery } from '@src/store/slice/addressSlice';

function getInput(handleModalWarning, name3) {
  return (props) => (
    <CustomInput
      {...props}
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput-input"
      numeric="numeric"
      placeholder={name3}
      height={36}
      maxLength={50}
      onBlur={() => handleModalWarning()}
    />
  );
}

function getInput1(surname2) {
  return (props) => (
    <CustomInput
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput1-input"
      numeric="numeric"
      maxLength={50}
      upperCase="upperCase"
      {...props}
      placeholder={surname2}
      height={36}
    />
  );
}

function getInput2(checkIsMobile) {
  return (props) => (
    <CustomMaskInput
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput2-maskInput"
      onChange={() => checkIsMobile()}
      onBlur={() => checkIsMobile()}
      {...props}
      mask={'+\\90 (999) 999 99 99'}
    >
      <CustomInput
        id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput2-input"
        placeholder={'+90 (___) ___ __ __'}
        height={36}
      />
    </CustomMaskInput>
  );
}

function getInput3(currentCardOrder, handleCheck) {
  return (props) => (
    <CustomCheckbox
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-mobilePaymentAuthorization-checkbox"
      disabled={currentCardOrder?.cardType === 1}
      {...props}
      onChange={handleCheck}
    />
  );
}

function getInput4(amount3) {
  return (props) => (
    <CustomMoneyInput
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput4-moneyInput"
      {...props}
      placeholder={amount3}
      height={36}
    />
  );
}

function getInput5(max20Digits) {
  return (props) => (
    <CustomInput
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput5-input"
      {...props}
      placeholder={max20Digits}
      height={36}
      maxLength={20}
    />
  );
}

function getInput6(editableAddressRender, record) {
  return (props) => {
    return (
      <>
        {editableAddressRender(record?.addressText, record)}
        <CustomInput
          {...props}
          id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput6-input"
          value={record.addressId}
          disabled
          style={{ display: 'none' }}
          height={36}
        />
      </>
    );
  };
}

const CardDetailInformation = ({ form }) => {
  const history = useHistory();
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const { cardList, tableProperty, selectedRow, allCardAddressCheckedData } = useSelector(
    (state) => state?.cardOrderDetails,
  );
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { maximumLoadedAmount } = useSelector((state) => state?.orderLimits);
  const { addressListByUserQuery } = useSelector((state) => state?.address);

  const dispatch = useDispatch();
  const [isModalDeliveryAddressChoose, setIsModalDeliveryAddressChoose] = useState(false);
  const [isModalDeliveryAddressAdd, setIsModalDeliveryAddressAdd] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [modalVisibled, setModalVisibled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isEditing = (record) => record.id === editingKey;
  const [gsmRequired, setGsmRequired] = useState(false);
  const [addRowCounter, setAddRowCounter] = useState(0);

  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');
  const maximumLoadingLimitPerCardIs = useText('maximumLoadingLimitPerCardIs');
  const cardInformation2 = useText('cardInformation2');
  const recordAddedSuccessfully = useText('recordAddedSuccessfully');
  const deleteCardConfirmation = useText('deleteCardConfirmation');
  const name3 = useText('name3');
  const amount3 = useText('amount3');
  const max20Digits = useText('max20Digits');
  const surname2 = useText('surname2');

  useLayoutEffect(() => {
    if (cardList.length === 0) {
      handleAdd();
    }
  }, [cardList]);

  const handleAdd = useCallback(() => {
    const control = cardList?.filter((recordItem) => recordItem?.id === undefined);
    if (control.length > 0) {
      const saveButton = document.getElementsByClassName('table-save-button');
      saveButton && saveButton?.length > 0 && saveButton[0]?.click();
      dispatch(setCardList([...cardList]));
    } else if (allCardAddressCheckedData?.addressId) {
      dispatch(setCardList([...cardList, { ...allCardAddressCheckedData }]));
      form.resetFields();
      form.setFieldsValue({
        ...allCardAddressCheckedData,
      });
    } else {
      dispatch(setCardList([...cardList, {}]));
      form.resetFields();
    }
    setEditingKey(undefined);
    setAddRowCounter((count) => count + 1);
  }, [allCardAddressCheckedData, cardList, dispatch, form]);

  const tableRowUpdate = useCallback(
    (response) => {
      const row = { ...response?.data };
      const newData = [...cardList];
      const index = newData.findIndex((recordItem) => row.id === recordItem.id);
      const item = newData[index];
      newData.splice(index, 1, { ...item, ...row });
      dispatch(setCardList(newData));
      form.resetFields();
      setEditingKey('');
      successDialog({
        title: <Text t="successfullySent" />,
        message: recordAddedSuccessfully,
      });
    },
    [cardList, dispatch, form],
  );

  const checkIsMobile = useCallback(async () => {
    let isMobileChecked = false;
    const fieldsValues = await form.getFieldsValue();
    try {
      await form.validateFields();
      form.setFieldsValue({ ...fieldsValues, mobilePaymentAuthorization: fieldsValues.gsm !== '' });
    } catch (error) {
      const gsmError = error?.errorFields?.filter((item) => item.name[0] === 'gsm');
      isMobileChecked = gsmError.length > 0;
      form.setFieldsValue({
        ...fieldsValues,
        mobilePaymentAuthorization: fieldsValues.gsm ? !isMobileChecked : isMobileChecked,
      });
    }
  }, [form]);

  const saveDetail = useCallback(
    async (record) => {
      try {
        const values = await form.validateFields();
        if (
          isGreaterMaximumLoadedAmount({
            controlValue: maximumLoadedAmount,
            price: values.price,
          })
        ) {
          errorDialog({
            title: <Text t="error" />,
            message: maximumLoadingLimitPerCardIs.replaceAll('{amount}', maximumLoadedAmount),
          });
          return;
        }
        const body = {
          ...values,
          refNo: values?.refNo ? values?.refNo : null,
          gsm: !values?.gsm
            ? null
            : values?.gsm
              ?.replace(/\)/g, '')
              ?.replace(/\(/g, '')
              ?.replace(/-/g, '')
              ?.replace(/ /g, ''),
        };
        const action = await dispatch(cardOrderDetailSave(body));
        if (cardOrderDetailSave.fulfilled.match(action)) {
          const updatedRefNo = action?.payload?.data?.refNo;
          const refNo = updatedRefNo || null;

          if (action?.payload?.data?.errorMessage) {
            confirmDialog({
              title: <Text t="attention" />,
              message: action?.payload?.data?.errorMessage,
              cancelText: "Kart İşlemleri'ne Git",
              okText: 'Devam Et',
              onOk: async () => {
                const result = await dispatch(cardOrderDetailSave({ isContinue: true, ...body }));
                tableRowUpdate({
                  ...result?.payload,
                  data: { ...result?.payload?.data, addressText: record?.addressText, refNo },
                });
              },
              onCancel: async (closeByIconOrEsc) => {
                if (!closeByIconOrEsc) {
                  history.push({
                    pathname: '/ticket-restaurant/manage-my-cards',
                  });
                }
              },
              maskClosable: true,
            });
          } else {
            tableRowUpdate({
              ...action?.payload,
              data: { ...action?.payload?.data, addressText: record?.addressText, refNo },
            });
          }
        }

        if (cardOrderDetailSave.rejected.match(action)) {
          if (action?.payload?.data?.length > 0) {
            errorDialog({
              title: <Text t="error" />,
              message: action?.payload?.data?.join('\n'),
            });
          } else {
            errorDialog({
              title: <Text t="error" />,
              message: action?.payload?.error?.message,
            });
          }
        }
      } catch (error) { }
    },
    [dispatch, form, tableRowUpdate],
  );

  const handleSave = useCallback(
    async (record) => {
      if (isLoading) return;
      setIsLoading(true);

      try {
        const { id, cardOrderDetails, ...cardOrderBody } = currentCardOrder;
        if (id === 0) {
          const action = await dispatch(cardOrdersSave(cardOrderBody));
          if (cardOrdersSave.fulfilled.match(action)) {
            await saveDetail(record);
          }
        } else {
          await saveDetail(record);
        }
      } catch (e) {
        console.error('Error in handleSave:', e);
      } finally {
        setIsLoading(false);
      }
    },
    [currentCardOrder, dispatch, saveDetail, isLoading],
  );

  const handleUpdate = useCallback(
    async (record) => {
      if (isLoading) return;
      setIsLoading(true);

      try {
        const values = await form.validateFields();
        if (
          isGreaterMaximumLoadedAmount({
            controlValue: maximumLoadedAmount,
            price: values.price,
          })
        ) {
          errorDialog({
            title: <Text t="error" />,
            message: maximumLoadingLimitPerCardIs.replaceAll('{amount}', maximumLoadedAmount),
          });
          setIsLoading(false);
          return;
        }

        const body = {
          id: record?.id,
          ...values,
          refNo: values?.refNo ? values?.refNo : null,
          gsm: values?.gsm
            ? values.gsm.replace(/\)/g, '').replace(/\(/g, '').replace(/-/g, '').replace(/ /g, '')
            : null,
        };

        const action = await dispatch(cardOrderDetailUpdate(body));
        if (cardOrderDetailUpdate.fulfilled.match(action)) {
          const updatedRefNo = action?.payload?.data?.refNo;
          const refNo = updatedRefNo || null;
          tableRowUpdate({
            ...action?.payload,
            data: {
              ...action?.payload?.data,
              addressText: record?.addressText,
              refNo,
              gsm: body?.gsm,
            },
          });
        } else if (cardOrderDetailUpdate.rejected.match(action)) {
          const errorMessage =
            action?.payload?.data?.length > 0
              ? action.payload.data.join('\n')
              : action?.payload?.error?.message;

          errorDialog({
            title: <Text t="error" />,
            message: errorMessage,
          });
        }
      } catch (error) {
        console.error('Error in handleUpdate:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, form, maximumLoadedAmount, tableRowUpdate, isLoading],
  );

  const handleDelete = useCallback(
    (record) => {
      confirmDialog({
        title: <Text t="attention" />,
        message: deleteCardConfirmation,
        okText: <Text t="delete" />,
        cancelText: <Text t="giveUp" />,
        onOk: async () => {
          const action = await dispatch(cardOrderDetailDelete({ id: record?.id }));
          if (cardOrderDetailDelete.fulfilled.match(action)) {
            const newCardList = cardList.filter((item) => item?.id !== record?.id);
            successDialog({
              title: <Text t="successfullySent" />,
              message: action?.payload?.message || yourTransactionHasBeenSuccessfullyCompleted,
              onOk: () => {
                dispatch(setCardList(newCardList));
              },
            });
          }
        },
      });
    },
    [cardList, dispatch],
  );

  const handleEdit = useCallback(
    (record) => {
      setEditingKey(record?.id);
      if (record.id) {
        form.setFieldsValue({
          ...record,
        });
        return;
      }
      form.resetFields();
    },
    [form, editingKey],
  );

  const handleGiveUp = useCallback(() => {
    setEditingKey('');
    form.resetFields();
  }, [form]);

  const handleSaveGiveUp = useCallback(() => {
    const newCardList = cardList?.filter((item) => item?.id !== undefined);
    setEditingKey('');
    form.resetFields();
    dispatch(setCardList(newCardList));
  }, [cardList, dispatch, form]);

  const handleTableChange = useCallback(
    async (pageNumber, pageSize) => {
      await dispatch(cardOrderDetailsGelAll({ pageNumber, pageSize }));
    },
    [dispatch],
  );

  const handleAddressChoose = useCallback(
    (record) => {
      dispatch(setSelectedRow({ ...record }));
      setIsModalDeliveryAddressChoose(true);
    },
    [dispatch],
  );

  const handleAddressAdd = useCallback(
    (record) => {
      dispatch(setSelectedRow({ ...record }));
      setIsModalDeliveryAddressAdd(true);
    },
    [dispatch],
  );

  const handleSelectedAddress = useCallback(
    (selectedValues) => {
      if (selectedValues.addressText === '') return;
      const row = {
        ...selectedRow,
        addressId: selectedValues?.addressValue,
        addressText: selectedValues?.addressText,
      };
      form.setFieldsValue({
        ...row,
      });
      const newData = [...cardList];
      const index = newData.findIndex((recordItem) => row.id === recordItem.id);
      const item = newData[index];
      newData.splice(index, 1, { ...item, ...row });
      dispatch(setCardList(newData));
      if (selectedValues?.allCardAddressChecked !== undefined) {
        setIsModalDeliveryAddressChoose(false);
      } else {
        setIsModalDeliveryAddressAdd(false);
      }
    },
    [cardList, dispatch, form, selectedRow],
  );
  useEffect(() => {
    (async () => {
      if (addressListByUserQuery.length === 0) {
        await dispatch(
          addressGetPagedListByUserQuery({
            pageNumber: 0,
            pageSize: 0,
          }),
        );
      }
    })();
  }, []);

  useEffect(async () => {
    if (currentCardOrder?.cardType === 0) {
      await handleCheck({ target: { checked: false } });
    } else {
      await handleCheck({ target: { checked: true } });
    }
  }, [currentCardOrder.cardType]);

  const editableActionButtons = (record) => {
    return record.id ? (
      <div className="card-detail-action-buttons">
        <Button
          id="cardOrders-cardInformation-cardDetailInformation-editable-row-update-btn"
          onClick={() => handleUpdate(record)}
          className="editable-row-update-btn"
          disabled={isLoading}
        >
          <Text t="saveBtn" />
        </Button>

        <Typography.Link onClick={handleGiveUp} className={'editable-row-give-up-btn'}>
          <Text t="giveUp" />
        </Typography.Link>
      </div>
    ) : (
      <div className="card-detail-action-buttons">
        <Button
          id="cardOrders-cardInformation-cardDetailInformation-editable-row-save-btn"
          onClick={() => handleSave(record)}
          className="editable-row-save-btn"
          disabled={isLoading}
        >
          <Text t="saveBtn" />
        </Button>

        <Button
          id="cardOrders-cardInformation-cardDetailInformation-table-row-delete-btn"
          onClick={handleSaveGiveUp}
          className={'table-row-delete-btn'}
          style={{ backgroundColor: '#f72717' }}
        >
          <Text t="delete" />
        </Button>
      </div>
    );
  };

  const deliveryAddressClickHandler = useCallback((record) => {
    return handleAddressChoose(record);
  }, []);

  const editableAddressRender = (deliveryAddress, record) => {
    return deliveryAddress ? (
      <span
        className="table-cell-address-choose"
        onClick={() => deliveryAddressClickHandler(record)}
      >
        {deliveryAddress}
      </span>
    ) : (
      <>
        <span className="table-cell-address-choose" onClick={() => handleAddressChoose(record)}>
          <Text t="selectAddress2" />
        </span>
        <span> / </span>
        <span className="table-cell-address-add" onClick={() => handleAddressAdd(record)}>
          <Text t="addNew2" />
        </span>
      </>
    );
  };

  const noEditAddressRender = (deliveryAddress) => {
    return deliveryAddress || <Text t="noAddress" />;
  };

  const handleDownloadExcel = useCallback(async () => {
    try {
      const data = await cardOrderDetailsServices.getCardOrderDetailExcelTemplate({
        PrintNameSurname: currentCardOrder?.cardType === 0 && currentCardOrder?.printNameSurname,
        customerId: selectedCustomer?.customerId,
        cardType: currentCardOrder?.cardType,
      });
      download(
        data,
        `${getFileNameByLanguage('yeni-kart-ekle', 'add-new-card')}-${dayjs().format('DD-MM-YYYY hh:mm')}.xlsx`,
      );
    } catch (error) {
      errorDialog({
        title: <Text t="error" />,
        message: error?.statusText,
      });
    }
  }, [
    selectedCustomer?.customerId,
    currentCardOrder?.cardType,
    currentCardOrder?.printNameSurname,
  ]);

  useEffect(() => {
    if (currentCardOrder?.cardType === 0) {
      setGsmRequired(true);
    } else {
      setGsmRequired(false);
    }
  }, [currentCardOrder?.cardType]);

  const handleCheck = async (e) => {
    const val = e?.target?.checked;
    const fieldsValues = await form.getFieldsValue();
    form.setFieldsValue({ ...fieldsValues, mobilePaymentAuthorization: val });
    if (!!val && currentCardOrder?.cardType === 0) {
      setGsmRequired(true);
    } else {
      setGsmRequired(false);
    }
  };

  const firstPart = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: 70,
      render: (_, __, index) =>
        (tableProperty?.currentPage - 1) * tableProperty?.pageSize + index + 1,
    },
    {
      title:
        currentCardOrder?.cardType === 0 && currentCardOrder?.printNameSurname ? (
          <>
            <Text t="nameUpperCase" /> <span className={'table-header-validation'}>*</span>
          </>
        ) : (
          <Text t="nameUpperCase" />
        ),
      dataIndex: 'name',
      key: 'name',
      width: 162.7,
      onCell: (record) => ({
        record,
        input: getInput(handleModalWarning,name3),
        dataIndex: 'name',
        editing: isEditing(record),
        required: currentCardOrder?.cardType === 0 && currentCardOrder?.printNameSurname,
      }),
    },
    {
      title:
        currentCardOrder?.cardType === 0 && currentCardOrder?.printNameSurname ? (
          <>
            <Text t="surnameUpperCase" />
            <span className={'table-header-validation'}>*</span>
          </>
        ) : (
          <Text t="surnameUpperCase" />
        ),
      dataIndex: 'surname',
      key: 'surname',
      width: 162.7,
      onCell: (record) => ({
        record,
        input: getInput1(surname2),
        dataIndex: 'surname',
        editing: isEditing(record),
        required: currentCardOrder?.cardType === 0 && currentCardOrder?.printNameSurname,
      }),
    },
    {
      title: (
        <>
          {currentCardOrder?.cardType === 1 || (currentCardOrder?.cardType === 0 && gsmRequired) ? (
            <>
              <Text t="gsmNoUpperCase" />
              <span className={'table-header-validation'}>*</span>
            </>
          ) : (
            <Text t="gsmNoUpperCase" />
          )}
        </>
      ),
      dataIndex: 'gsm',
      key: 'gsm',
      width: 170,
      onCell: (record) => ({
        record,
        input: getInput2(checkIsMobile),
        rules: (fields, value) => {
          if (
            (!!value && value !== '+90 (___) ___ __ __') ||
            currentCardOrder?.cardType === 1 ||
            (currentCardOrder?.cardType === 0 && gsmRequired)
          ) {
            return formPhoneRegex(fields, value);
          }
          return Promise.resolve();
        },
        dataIndex: 'gsm',
        editing: isEditing(record),
        required:
          currentCardOrder?.cardType === 1 || (currentCardOrder?.cardType === 0 && gsmRequired),
      }),
    },
    {
      title: (
        <span className="d-flex">
          <Text t="mobilePayment" />{' '}
          <Tooltip title={useText('mobilePaymentPermissionAllowsYourEmployeesToEasily')}>
            {' '}
            <CustomImage src={iconInfo} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'mobilePaymentAuthorization',
      key: 'mobilePaymentAuthorization',
      width: 100,
      align: 'center',
      onCell: (record) => ({
        record,
        input: getInput3(currentCardOrder, handleCheck),
        dataIndex: 'mobilePaymentAuthorization',
        editing: isEditing(record),
        inputType: 'checkbox',
      }),
      render: (text) => (
        <span>
          {text ? (
            <CustomImage src={iconChecked} alt="check" />
          ) : (
            <CustomImage src={iconNoChecked} alt="uncheck" />
          )}
        </span>
      ),
    },
  ];

  const secondPart = [
    {
      title: <Text t="totalPrice" />,
      dataIndex: 'price',
      key: 'price',
      width: 120,
      align: 'right',
      onCell: (record) => ({
        record,
        input: getInput4(amount3),
        dataIndex: 'price',
        editing: isEditing(record),
        required: false,
      }),
      render: (text) => <span>{text ? `${moneyFormat(text, false)}` : '0'}</span>,
    },
    {
      title: (
        <span>
          REF.NO
          <Tooltip title={useText('thisIsTheNumberYouCanUseTo')}>
            {' '}
            <CustomImage src={iconInfo} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'refNo',
      key: 'refNo',
      width: 135,
      align: 'center',
      onCell: (record) => ({
        record,
        input: getInput5(max20Digits),
        dataIndex: 'refNo',
        editing: isEditing(record),
        required: false,
      }),
    },
    {
      title: <Text t="action" />,
      dataIndex: 'action',
      key: 'action',
      width: 180,
      align: 'center',
      onCell: () => ({
        className: 'card-detail-action-cell',
      }),
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          editableActionButtons(record)
        ) : (
          <div className="card-detail-action-buttons">
            <Button
              id="cardOrders-cardInformation-cardDetailInformation-table-row-edit-btn"
              className={'table-row-edit-btn'}
              onClick={() => handleEdit(record)}
            >
              <Text t="edit" />
            </Button>

            <Button
              id="cardOrders-cardInformation-cardDetailInformation-second-table-row-delete-btn"
              className={'table-row-delete-btn'}
              onClick={() => handleDelete(record)}
              style={{ backgroundColor: '#f72717' }}
            >
              <Text t="delete" />
            </Button>
          </div>
        );
      },
    },
  ];

  const middlePart = [
    {
      title: (
        <>
          {currentCardOrder?.cardType === 1 ? (
            <Text t="registeredDeliveryAddresses" />
          ) : (
            <Text t="deliveryAddressUpperCase" />
          )}{' '}
          <span className={'table-header-validation'}>*</span>
        </>
      ),
      dataIndex: 'addressId',
      key: 'addressId',
      width: 132.7,
      align: 'center',
      onCell: (record) => ({
        record,
        input: getInput6(editableAddressRender, record),
        dataIndex: 'addressId',
        editing: isEditing(record),
        required: !record?.addressId,
      }),
      render: (_, record) => {
        return noEditAddressRender(record?.addressText);
      },
    },
  ];

  const columns = [...firstPart, ...middlePart, ...secondPart];

  const handleModalWarning = async () => {
    if (
      modalVisibled === false &&
      currentCardOrder?.cardType === 0 &&
      currentCardOrder?.printNameSurname === false
    ) {
      warningDialog({
        title: <Text t="attention" />,
        htmlContent: (
          <Text
            t={`<div>
                     Kart basım seçeneklerinde yer alan <b>Ad ve Soyad basılsın</b> seçeneğini
                    seçmediğiniz durumda bu bilgileri girseniz dahi kartların üzerine basılmayacaktır.
                  </div>`}
          />
        ),
        onOk: () => {
          setModalVisibled(true);
        },
      });
    }
  };

  return (
    <>
      {currentCardOrder?.cardType !== 2 && (
        <CustomCollapseCard cardTitle={cardInformation2}>
          <div className="card-information-header-tools">
            <CustomButton
              id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-download-btn"
              className="download-btn"
              onClick={handleDownloadExcel}
            >
              <CustomImage src={downloadIcon} />
              <Text t="downloadExcelTemplate" />
            </CustomButton>
            <CustomButton
              id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-upload-btn"
              className="upload-btn"
              onClick={() => setUploadModalVisible(true)}
            >
              <CustomImage src={uploadIcon} />
              <Text t="uploadWithExcel" />
              <CustomImage src={excelIcon} />
            </CustomButton>
          </div>
          <Form
            form={form}
            initialValues={currentCardOrder?.cardType === 1 && { mobilePaymentAuthorization: true }}
            component={false}
          >
            <CustomTable
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              pagination={false}
              dataSource={cardList}
              columns={columns}
              rowKey={(record) => `card-order-${record?.id || record?.addressId}`}
            />
          </Form>
          <div className="person-information-table-footer">
            <div className="d-flex">
              <Button
                id="cardOrders-cardInformation-cardDetailInformation-table-row-add-btn"
                onClick={handleAdd}
                className={'table-row-add-btn'}
              >
                <CustomImage src={iconPlus} alt="iconPlus" />
                <Text t="addNewName" />
              </Button>
              <CustomPagination
                current={tableProperty?.currentPage}
                defaultCurrent={1}
                pageSize={tableProperty?.pageSize}
                total={tableProperty?.totalCount}
                onChange={async (pageNumber, pageSize) => {
                  await handleTableChange(pageNumber, pageSize);
                }}
              />
            </div>
            <div className="footer-info-container">
              <div className="footer-info-content">
                <CustomImage src={cardIcon} />
                <Text t="total" />
                <span>{currentCardOrder?.totalCount}</span> <Text t="cardsAdded" />
              </div>
              <div className="total-amount-title">
                <Text t="totalBalanceToBeLoadedUpperCaseColon" />
                <span>{moneyFormat(currentCardOrder?.totalPrice, true)}</span>
              </div>
            </div>
          </div>
          <DeliveryAddressAddForm
            modalVisible={isModalDeliveryAddressAdd}
            handleModalVisible={setIsModalDeliveryAddressAdd}
            handleSelectedAddress={handleSelectedAddress}
          />
          <DeliveryAddressChooseForm
            modalVisible={isModalDeliveryAddressChoose}
            handleModalVisible={setIsModalDeliveryAddressChoose}
            handleAddFormModalVisible={setIsModalDeliveryAddressAdd}
            handleSelectedAddress={handleSelectedAddress}
          />
          <UploadFileModal
            modalVisible={uploadModalVisible}
            handleModalVisible={setUploadModalVisible}
          />
        </CustomCollapseCard>
      )}
    </>
  );
};

export default CardDetailInformation;
